import './index.css';
import { render } from 'preact';
import { App } from './App.js';

const rootEl = document.getElementById('app');
if (rootEl) {
  render(<App />, rootEl);
}
